<template>
  <div>
    <the-headersider />

    <base-card class="card">
      <h2 class="title">Register Client</h2>

      <form @submit.prevent="createClient">
        <div class="form-grid">
          <!-- Client Name -->
          <div class="form-group">
            <label>Client Name *</label>
            <input
              type="text"
              v-model.trim="formData.client_name"
              required
              placeholder="John Doe"
            />
          </div>

          <!-- Phone -->
          <div class="form-group">
            <label>Phone Number *</label>
            <input
              type="tel"
              v-model.trim="formData.phone"
              required
              placeholder="07XXXXXXXX"
            />
          </div>

          <!-- Alternative Phone -->
          <div class="form-group">
            <label>Alternative Phone</label>
            <input
              type="tel"
              v-model.trim="formData.alternative_phone"
              placeholder="Optional"
            />
          </div>
          <div class="form-group">
            <label> Email</label>
            <input
              type="text"
              v-model.trim="formData.email"
              placeholder="a@gmail.com"
            />
          </div>

          <!-- Estate -->
          <!-- <div class="form-group">
            <label>Estate *</label>
            <input
              type="text"
              v-model.trim="formData.estate"
              required
              placeholder="e.g. Pipeline"
            />
          </div> -->

          <!-- Apartment -->

          <div class="form-group">
            <label>landmard *</label>
            <input
              type="text"
              v-model.trim="formData.landmark"
              required
              placeholder="Katani primary"
            />
          </div>
          <div class="form-group">
            <label>Gla Champion *</label>
            <input
              type="text"
              v-model.trim="formData.gla_campion"
              placeholder="Dennis"
            />
          </div>

          <div class="form-group">
            <label class="label">Estate</label>
            <div class="select">
              <select v-model="formData.estateDetails">
                <option disabled value="">Select a Estate</option>

                <option v-for="estate in estates" :key="estate.id">
                  {{ estate.estateId }} {{ estate.estateName }}
                </option>
              </select>
            </div>
          </div>
          <div class="form-group">
            <label>Apartment *</label>
            <div class="select">
              <select v-model="formData.apartment">
                <option disabled value="">Select a Apartment</option>

                <option v-for="apartment in apartments" :key="apartment.id">
                  {{ apartment.apartment_name }}
                </option>
              </select>
            </div>
           
          </div>
          <div class="form-group">
            <label> House No *</label>
            <input
              type="text"
              v-model.trim="formData.house_number"
              required
              placeholder="A12"
            />
          </div>

          <!-- Monthly Bill -->
          <div class="form-group">
            <label>Monthly Bill (KES) *</label>
            <input
              type="number"
              v-model.number="formData.monthly_payment"
              required
              min="0"
            />
          </div>

          <!-- Starting Bill -->
          <div class="form-group">
            <label>Starting Bill (KES)</label>
            <input
              type="number"
              v-model.number="formData.starting_bill"
              min="0"
            />
          </div>
          <!-- <div class="form-group">
            <div class="select">
              <select v-model="formData.client_type">
                <option disabled value="">Client type</option>
                <option value="">normal</option>
                <option value="">corporate</option>
              </select>
            </div>
          </div> -->
                <div class="form-group">
            <label>Apartment *</label>
            <div class="select">
              <select v-model="formData.client_type">
                <option disabled value="">Select client</option>

                 <option value="normal">Normal</option>
      <option value="corporate">Corporate</option>
              </select>
            </div>
           
          </div>

          

          <!-- Court -->
          <!-- <div class="form-group">
            <label>Estate </label>
            <select v-model="formData.estateDetails" required>
              <option disabled value="">Select Estate</option>
              <option
                v-for="estate in estates"
                :key="estate.id"
                :value="estate.estateDetails"
              >
                {{ estate.estateId }} - {{ estate.estateName }}
              </option>
            </select>
          </div> -->
        </div>

        <!-- Actions -->
        <div class="actions">
          <base-button :disabled="loading">
            {{ loading ? "Saving..." : "Register Client" }}
          </base-button>
        </div>
      </form>
    </base-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: false,
      formData: {
        client_name: "",
        phone: "",
        alternative_phone: "",
        apartment: "",
        house_number: "",
        estateDetails: "",
        gla_campion: "",
        landmark: "",
        email: "",
        client_type: "",

        monthly_payment: "",
        starting_bill: "",
      },
    };
  },

  computed: {
    estates() {
      return this.$store.getters.estates;
    },
    apartments() {
      return this.$store.getters.apartments;
    },
  },

  created() {
    this.$store.dispatch("LoadEstates");
    this.$store.dispatch("LoadApartments");
  },

  methods: {
    async createClient() {
      this.loading = true;

      try {
        await axios.post(
          "https://api.roberms.com/gla/client/registration/",
          this.formData,
        );

        this.$router.replace("/clients");
      } catch (error) {
        alert("Failed to register client. Please try again.");
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.card {
  max-width: 900px;
  margin: auto;
}

.title {
  margin-bottom: 1rem;
  font-size: 1.4rem;
  font-weight: bold;
  color: #2c3e50;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
}

.form-group label {
  font-weight: 600;
  margin-bottom: 0.3rem;
  display: block;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.55rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font: inherit;
}

.form-group input:focus,
.form-group select:focus {
  border-color: #3b82f6;
  outline: none;
  background: #f9fbff;
}

.actions {
  margin-top: 1.5rem;
  text-align: right;
}
</style>
